module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section02_02_beach-photo-0608bfe04ca365bce2304244561180b5.jpg";